import { Controller, useFormContext } from 'react-hook-form';

import { Label } from 'components/Label';
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from 'components/Select';
import { Textarea } from 'components/Textarea';
import { RHFDebounceSelect } from 'components/input/RHFDebounceSelect';
import { Flex, Grid } from 'components/layout';
import { CarrierFormConfig } from 'pages/QuoteView/Quoting/CarrierQuote/types';
import { CompanyCoreInfo } from 'types/Load';
import { Maybe } from 'types/UtilityTypes';
import {
  GenericCompanySearchableFields,
  mapCustomerToSelectOptions,
} from 'utils/loadInfoAndBuilding';

interface LoadInformationFormProps {
  config: CarrierFormConfig;
  customers: Maybe<CompanyCoreInfo[]>;
  handleRefreshCustomers: () => Promise<void>;
  handleResetCustomerSearch: () => void;
  handleCustomerSearch: (
    field: GenericCompanySearchableFields,
    value: string
  ) => Promise<any[]>;
  tmsIntegrations: any[];
}

export default function LoadInformationForm({
  config,
  customers,
  handleRefreshCustomers,
  handleResetCustomerSearch,
  handleCustomerSearch,
  tmsIntegrations,
}: LoadInformationFormProps) {
  const {
    control,
    formState: { errors },
  } = useFormContext();

  return (
    <Grid gap='md' className='w-full mx-0'>
      <div className='text-md whitespace-nowrap text-neutral-800 font-semibold'>
        Load Information
      </div>

      {/* Customer Search */}
      {config.showCustomerSearch &&
        tmsIntegrations &&
        tmsIntegrations.length > 0 && (
          <div>
            <RHFDebounceSelect
              required={false}
              name='customerId'
              label='Customer'
              control={control}
              errors={errors}
              data={customers}
              isLoading={false}
              showSearchParamDropdown={false}
              searchFieldDefault='nameAddress'
              refreshHandler={handleRefreshCustomers}
              resetOptionsHandler={handleResetCustomerSearch}
              fetchOptions={handleCustomerSearch}
              mapOptions={mapCustomerToSelectOptions}
              placeholder='Search by name or address'
            />
          </div>
        )}

      {/* NOTE: renamed field to Job Description for SDS (they are currently the only users of this config) */}
      {config.showItemDescription ? (
        <Flex direction='col' gap='xs'>
          <Label name={'itemDescription'}>Job Description</Label>
          <Controller
            name='itemDescription'
            control={control}
            render={({ field }) => (
              <Textarea
                {...field}
                placeholder='Enter description'
                className='min-h-[60px]'
              />
            )}
          />
        </Flex>
      ) : (
        <Flex direction='col' align='stretch' gap='xs' className='w-full'>
          {/* Transport Type */}
          <div className='w-full'>
            <Label name={'transportType'}>Transport Type</Label>
            <Controller
              name='transportType'
              control={control}
              rules={{ required: 'Required' }}
              render={({ field }) => (
                <Select onValueChange={field.onChange} value={field.value}>
                  <SelectTrigger className='w-full mt-1'>
                    <SelectValue placeholder='Choose' />
                  </SelectTrigger>
                  <SelectContent>
                    <SelectItem value='VAN'>VAN</SelectItem>
                    <SelectItem value='REEFER'>REEFER</SelectItem>
                    <SelectItem value='FLATBED'>FLATBED</SelectItem>
                    <SelectItem value='POWER_ONLY'>POWER ONLY</SelectItem>
                  </SelectContent>
                </Select>
              )}
            />
          </div>

          {/* Weight */}
          {/* <div className='flex items-center'>
            <div className='grow'>
              <Label name='weightLbs'>Weight</Label>
              <Controller
                name='weightLbs'
                control={control}
                rules={{
                  required: 'Weight is required',
                }}
                render={({ field }) => (
                  <Input
                    {...field}
                    type='number'
                    placeholder='Enter weight'
                    className='mt-1'
                  />
                )}
              />
            </div>
            <div className='flex-none ml-2'>
              <Label name='weightUnit'>Unit</Label>
              <Controller
                name='weightUnit'
                control={control}
                render={({ field }) => (
                  <Select
                    {...field}
                    showSearch
                    placeholder='Unit'
                    optionFilterProp='children'
                    filterOption={(input, option) =>
                      option?.children
                        .toLowerCase()
                        .indexOf(input.toLowerCase()) >= 0
                    }
                  >
                    {weightUnits.map((unit) => (
                      <Option key={unit} value={unit}>
                        {unit}
                      </Option>
                    ))}
                  </Select>
                )}
              />
            </div>
          </div> */}
        </Flex>
      )}
    </Grid>
  );
}
